import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useHeaderMenuLargeStyles = (theme: Theme, _selectedTheme: number) => {
  return {
    root: css({
      width: '100%',
      display: 'flex',
      flexFlow: 'row',
      alignItems: 'center',
      maxHeight: 70,
      gap: theme.spacing(3),
    }),
    leftSection: css({
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'left',
      alignItems: 'center',
      flexGrow: 0,
      flexShrink: 0,
      gap: theme.spacing(1.5),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(1.5),
      },
      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(2),
      },
      [theme.breakpoints.up('xl')]: {
        paddingLeft: theme.spacing(2.5),
      },
    }),
    centerSection: css({
      display: 'flex',
      flexFlow: 'row',
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: 'nowrap',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      marginLeft: 'auto',
      marginRight: 'auto',

      [theme.breakpoints.up('sm')]: {
        paddingRight: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.up('lg')]: {
        paddingRight: theme.spacing(4),
      },
      [theme.breakpoints.up('xl')]: {
        paddingRight: theme.spacing(5),
      },
    }),
    rightSection: css({
      display: 'flex',
      flexFlow: 'row',
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: 'nowrap',
      justifyContent: 'right',
      alignItems: 'center',
      gap: theme.spacing(2),

      [theme.breakpoints.up('sm')]: {
        paddingRight: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.up('lg')]: {
        paddingRight: theme.spacing(2.5),
      },
      [theme.breakpoints.up('xl')]: {
        paddingRight: theme.spacing(3),
      },
    }),
    divider: css({
      '&.MuiDivider-root': {
        marginLeft: theme.spacing(-0.5),
        marginRight: theme.spacing(1),
        height: 32,
        borderColor: 'rgba(15,23,42,0.12)',
      },
    }),
  };
};

export const useMenuSectionStyles = (theme: Theme) => {
  return {
    root: css({
      '&.MuiMenuItem-root': {
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        '&:hover': {
          backgroundColor: 'rgba(14,165,233,0.08)',
          cursor: 'default',
        },
      },
    }),
    headerMenuSectionText: css({
      '& .MuiTypography-subtitle1': {
        color: theme.palette.primary.main,
        fontSize: 16,
        fontWeight: theme.typography.fontWeightBold,
        textTransform: 'uppercase',
      },
    }),
  };
};
